// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader-3chLLjz","text":"text-1IAHA3x","title":"title-2cmoqAF","subtitle":"subtitle-IsJcL6I","image":"image-3-ymd5U","rotation":"rotation-2Tq8nmg"};